import { render } from "./LegalSectionRenderer.vue?vue&type=template&id=2cd7a1c6&scoped=true"
import script from "./LegalSectionRenderer.vue?vue&type=script&lang=js"
export * from "./LegalSectionRenderer.vue?vue&type=script&lang=js"

import "./LegalSectionRenderer.vue?vue&type=style&index=0&id=2cd7a1c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd7a1c6"]])

export default __exports__